import React from 'react'
import { Box, Flex, ListItem, OrderedList, Text } from '@chakra-ui/react'
import RouterUrl from '@constants/router.constant'

const TERMS_CONDITIONS = [
  {
    desc: 'Habbit Points Membership is powered by Advocado. To be eligible to join, you must accept the PDPA terms to allow Habbit and Advocado to use your personal data for marketing purposes.'
  },
  {
    desc: 'Habbit Point Membership program offers 4 membership tiers as follows: "Classic", "Silver", "Gold", and "Platinum".'
  },
  {
    desc: 'Habbit reserves the right to hold the issuance of qualifying points earned until the qualifying transactions, including payment, delivery and after 14 days money back guarantee period is complete.'
  },
  {
    desc: 'Qualifying points can be earned through these channels.',
    subDesc: [
      { content: 'a.  Habbit website - https://habbit.sg/' },
      {
        content: 'b. Call Centre order (coming soon) - +65 6742 2007'
      },
      {
        content:
          'c.  JML Experience Store (coming soon) - JML @ Paya Labar Square, JML @ Causeway Point'
      }
    ]
  },
  { desc: 'Habbit Points will be valid for 365 from issuance.' },
  {
    desc: 'There will strictly be no qualifying points earned from returned, refunded, partial refund, or cancelled orders.'
  },
  {
    desc: 'Upon expiration of your membership tenure in a particular tier and if you have yet to earn sufficient qualifying    points to be retained in that tier, you shall be downgraded to the relevant membership tier.'
  },
  {
    desc: 'Habbit Points Membership is non-transferable and shall be for the personal use of Habbit users only.'
  },
  { desc: 'Rewards must be used within their applicable validity period.' },
  {
    desc: 'There will strictly be no extension of the validity period for any rewards.'
  },
  {
    desc: 'Rewards are not redeemable for any cash or exchangeable for other rewards under any circumstances.'
  },
  {
    desc: 'Rewards cannot be sold, resold, exchanged, or transferred for value under any circumstances.'
  },
  {
    desc: 'Rewards shall not be regarded, construed, or used as valuable or exchangeable instruments under any circumstances.'
  },
  {
    desc: 'Habbit retains the right to reject any reward that has been tampered with or found in any way unacceptable or remove privilege or usage if deemed to have been linked to fraudulent activities.'
  },
  {
    desc: 'Habbit is not responsible for any accidental usage or cancellation of rewards, and no replacement will be provided in these circumstances.'
  },
  {
    desc: 'Habbit may suspend the calculation and accrual of qualifying points to rectify any errors in calculation or adjust the calculation as it reasonably deems fit without any prior notice or reason.'
  },
  {
    desc: 'Fraud, abuse of redemptions or any dishonest activities related to Habbit Points Membership program may result in the forfeiture of accumulated qualifying points and tier rewards, as well as a demotion of your membership tier, cancellation of your Habbit Point Membership program membership, or termination of your account.'
  },
  {
    desc: 'To the extent permitted by applicable laws, Habbit reserves the right at any time to change the following terms with prior notice to you at its sole discretion:',
    subDesc: [
      {
        content:
          'a. Vary, modify, or amend the terms and conditions of the Habbit Points Membership program (including adding or deleting any terms).'
      },
      {
        content:
          'b. Terminate or modify the Habbit Points Membership program        '
      },
      {
        content:
          'c. Revoke, adjust and/or recalculate any qualifying points awarded.        '
      },
      {
        content:
          'd. Change the rewards or substitute any reward with another of a similar value.        '
      },
      {
        content:
          'e. Change the number of qualifying points that can be earned on spending on qualifying transactions.        '
      },
      {
        content:
          'f. Modify the qualifications and eligibility for earning qualifying points.        '
      },
      {
        content: 'g. Modify the activities that earn qualifying points.        '
      },
      {
        content:
          'h. Modify the methods used to calculate the number of qualifying points awarded.         '
      },
      {
        content:
          'i. Withhold or cease the awarding of qualifying points to you.         '
      },
      {
        content:
          'j. Modify the qualifying points or other membership tier upgrades and renewals criteria.         '
      },
      {
        content:
          'k. Change or withdraw any benefits related to a particular membership tier.          '
      },
      {
        content: 'l. Change the duration taken for qualifying points to expire'
      }
    ]
  }
]

const TermsConditions = () => {
  return (
    <Flex
      mt={'80px'}
      gap={'23px'}
      flexDirection={'column'}
      id={RouterUrl.ANCHOR.REWARD_POINTS_T_C}
      data-aos="fade-up"
    >
      <Box w={'100%'}>
        <Text
          textStyle={'voucherPoint'}
          w={'auto'}
          borderBottom={'1px solid black'}
          textAlign={'start'}
          display={'inline-block'}
        >
          Terms & Conditions
        </Text>
      </Box>

      <OrderedList spacing={'2px'} pl={3}>
        {TERMS_CONDITIONS.map((tc, k) => {
          return (
            <ListItem key={k} textStyle={'termsConditions'}>
              <Text textStyle={'termsConditions'}>{tc.desc}</Text>
              {tc.subDesc && (
                <OrderedList
                  w={'92%'}
                  my={'10px'}
                  mx={'7%'}
                  spacing={'2px'}
                  styleType={'none'}
                >
                  {tc.subDesc.map((sd, k) => {
                    return (
                      <ListItem key={k} textStyle={'termsConditions'}>
                        <Text textStyle={'termsConditions'}>{sd.content}</Text>
                      </ListItem>
                    )
                  })}
                </OrderedList>
              )}
            </ListItem>
          )
        })}
      </OrderedList>
    </Flex>
  )
}

export default TermsConditions
